import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
const VueCookie = require('vue-cookie')
import VueCurrencyInput from 'vue-currency-input'
import VueTheMask from 'vue-the-mask'
import VueMask from 'v-mask'
import VueCompositionAPI from '@vue/composition-api'
import 'vue-date-pick/dist/vueDatePick.css'
import { CChartLine } from '@coreui/vue-chartjs'
const VueScrollTo = require('vue-scrollto')
const VueMoment = require('vue-moment')
const moment = require('moment')
require('moment/locale/pt-br')

Vue.config.performance = true

Vue.use(CoreuiVue)
    .use(VueCookie)
    .use(VueMoment, {moment})
    .use(VueCurrencyInput, {
      globalOptions: {
        currency: 'BRL'
      }
    })
    .use(VueTheMask)
    .use(VueMask)
    .use(VueScrollTo, {
        container: "body",
        duration: 500,
        easing: "ease",
        offset: -200,
        force: true,
        cancelable: true,
        onStart: false,
        onDone: false,
        onCancel: false,
        x: false,
        y: true
    })
    .use(VueCompositionAPI)

Vue.component('CChartLine', CChartLine)

Vue.prototype.$log = console.log.bind(console)

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
